import styled from "styled-components";

export const PeopleCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  width: 100%;
  gap: 16px;
`;

export const PeopleListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  flex: 1;
  width: 100%;
`;

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Link = styled.a`
  all: unset;
  cursor: pointer;

  & > div:first-of-type {
    height: 100%;
    box-sizing: border-box;
  }
`;
